"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromTxError = exports.fromCode = exports.InvalidFieldEnum = exports.MarketListIdNotInCategory = exports.MarketListIdIsAlreadyInCategory = exports.NoOrdersInOpenOrders = exports.TooManyAsks = exports.TooManyBids = exports.OneMarketPerMarketList = exports.MarketListHasNoBrackets = exports.InvalidLotSizes = exports.SerumMarketHasBeenClosed = exports.SerumMarketNotClosed = exports.BracketHasNotResolvedToNo = exports.BracketHasNotResolvedToYes = exports.WinningBracketIdInvalid = exports.MarketHasNotResolved = exports.MarketHasResolved = exports.NonzeroTempAccount = exports.NonzeroLockedFUsdc = exports.NonzeroLockedYes = exports.InsufficientTokens = exports.InsufficientUsdc = exports.InvalidQuantityLots = exports.InvalidPrice = exports.NotImplemented = void 0;
const programId_1 = require("./programId");
class NotImplemented extends Error {
    constructor() {
        super("6000: Function not yet implemented");
        this.code = 6000;
        this.name = "NotImplemented";
        this.msg = "Function not yet implemented";
    }
}
exports.NotImplemented = NotImplemented;
class InvalidPrice extends Error {
    constructor() {
        super("6001: Price must be between $0.001 and $0.999 per token");
        this.code = 6001;
        this.name = "InvalidPrice";
        this.msg = "Price must be between $0.001 and $0.999 per token";
    }
}
exports.InvalidPrice = InvalidPrice;
class InvalidQuantityLots extends Error {
    constructor() {
        super("6002: Orders must be a multiple of $0.01");
        this.code = 6002;
        this.name = "InvalidQuantityLots";
        this.msg = "Orders must be a multiple of $0.01";
    }
}
exports.InvalidQuantityLots = InvalidQuantityLots;
class InsufficientUsdc extends Error {
    constructor() {
        super("6003: Insufficient USDC");
        this.code = 6003;
        this.name = "InsufficientUsdc";
        this.msg = "Insufficient USDC";
    }
}
exports.InsufficientUsdc = InsufficientUsdc;
class InsufficientTokens extends Error {
    constructor() {
        super("6004: Insufficient tokens");
        this.code = 6004;
        this.name = "InsufficientTokens";
        this.msg = "Insufficient tokens";
    }
}
exports.InsufficientTokens = InsufficientTokens;
class NonzeroLockedYes extends Error {
    constructor() {
        super("6005: Locked Yes should have 0 tokens, if this happens your account is bricked somehow");
        this.code = 6005;
        this.name = "NonzeroLockedYes";
        this.msg = "Locked Yes should have 0 tokens, if this happens your account is bricked somehow";
    }
}
exports.NonzeroLockedYes = NonzeroLockedYes;
class NonzeroLockedFUsdc extends Error {
    constructor() {
        super("6006: Locked fUsdc should have 0 tokens, if this happens your account is bricked somehow");
        this.code = 6006;
        this.name = "NonzeroLockedFUsdc";
        this.msg = "Locked fUsdc should have 0 tokens, if this happens your account is bricked somehow";
    }
}
exports.NonzeroLockedFUsdc = NonzeroLockedFUsdc;
class NonzeroTempAccount extends Error {
    constructor() {
        super("6007: Temporary account should have 0 tokens");
        this.code = 6007;
        this.name = "NonzeroTempAccount";
        this.msg = "Temporary account should have 0 tokens";
    }
}
exports.NonzeroTempAccount = NonzeroTempAccount;
class MarketHasResolved extends Error {
    constructor() {
        super("6008: Cannot place an order, market has resolved");
        this.code = 6008;
        this.name = "MarketHasResolved";
        this.msg = "Cannot place an order, market has resolved";
    }
}
exports.MarketHasResolved = MarketHasResolved;
class MarketHasNotResolved extends Error {
    constructor() {
        super("6009: Market has not yet resolved");
        this.code = 6009;
        this.name = "MarketHasNotResolved";
        this.msg = "Market has not yet resolved";
    }
}
exports.MarketHasNotResolved = MarketHasNotResolved;
class WinningBracketIdInvalid extends Error {
    constructor() {
        super("6010: Winning bracket id is invalid");
        this.code = 6010;
        this.name = "WinningBracketIdInvalid";
        this.msg = "Winning bracket id is invalid";
    }
}
exports.WinningBracketIdInvalid = WinningBracketIdInvalid;
class BracketHasNotResolvedToYes extends Error {
    constructor() {
        super("6011: This Bracket has not resolved to Yes");
        this.code = 6011;
        this.name = "BracketHasNotResolvedToYes";
        this.msg = "This Bracket has not resolved to Yes";
    }
}
exports.BracketHasNotResolvedToYes = BracketHasNotResolvedToYes;
class BracketHasNotResolvedToNo extends Error {
    constructor() {
        super("6012: This Bracket has not resolved to No");
        this.code = 6012;
        this.name = "BracketHasNotResolvedToNo";
        this.msg = "This Bracket has not resolved to No";
    }
}
exports.BracketHasNotResolvedToNo = BracketHasNotResolvedToNo;
class SerumMarketNotClosed extends Error {
    constructor() {
        super("6013: Serum market hasn't been closed yet");
        this.code = 6013;
        this.name = "SerumMarketNotClosed";
        this.msg = "Serum market hasn't been closed yet";
    }
}
exports.SerumMarketNotClosed = SerumMarketNotClosed;
class SerumMarketHasBeenClosed extends Error {
    constructor() {
        super("6014: Serum market has been closed already");
        this.code = 6014;
        this.name = "SerumMarketHasBeenClosed";
        this.msg = "Serum market has been closed already";
    }
}
exports.SerumMarketHasBeenClosed = SerumMarketHasBeenClosed;
class InvalidLotSizes extends Error {
    constructor() {
        super("6015: Serum market lot sizes don't match expected values");
        this.code = 6015;
        this.name = "InvalidLotSizes";
        this.msg = "Serum market lot sizes don't match expected values";
    }
}
exports.InvalidLotSizes = InvalidLotSizes;
class MarketListHasNoBrackets extends Error {
    constructor() {
        super("6016: A MarketList without brackets cannot be added to a category");
        this.code = 6016;
        this.name = "MarketListHasNoBrackets";
        this.msg = "A MarketList without brackets cannot be added to a category";
    }
}
exports.MarketListHasNoBrackets = MarketListHasNoBrackets;
class OneMarketPerMarketList extends Error {
    constructor() {
        super("6017: Deprecating market list; only one market allowed per market list");
        this.code = 6017;
        this.name = "OneMarketPerMarketList";
        this.msg = "Deprecating market list; only one market allowed per market list";
    }
}
exports.OneMarketPerMarketList = OneMarketPerMarketList;
class TooManyBids extends Error {
    constructor() {
        super("6018: Too many orders on the bid queue, please prune orders");
        this.code = 6018;
        this.name = "TooManyBids";
        this.msg = "Too many orders on the bid queue, please prune orders";
    }
}
exports.TooManyBids = TooManyBids;
class TooManyAsks extends Error {
    constructor() {
        super("6019: Too many orders on the ask queue, please prune orders");
        this.code = 6019;
        this.name = "TooManyAsks";
        this.msg = "Too many orders on the ask queue, please prune orders";
    }
}
exports.TooManyAsks = TooManyAsks;
class NoOrdersInOpenOrders extends Error {
    constructor() {
        super("6020: No orders in this open orders account");
        this.code = 6020;
        this.name = "NoOrdersInOpenOrders";
        this.msg = "No orders in this open orders account";
    }
}
exports.NoOrdersInOpenOrders = NoOrdersInOpenOrders;
class MarketListIdIsAlreadyInCategory extends Error {
    constructor() {
        super("6021: The market list id to be added is already in the category");
        this.code = 6021;
        this.name = "MarketListIdIsAlreadyInCategory";
        this.msg = "The market list id to be added is already in the category";
    }
}
exports.MarketListIdIsAlreadyInCategory = MarketListIdIsAlreadyInCategory;
class MarketListIdNotInCategory extends Error {
    constructor() {
        super("6022: The market list id to be removed is not in the category");
        this.code = 6022;
        this.name = "MarketListIdNotInCategory";
        this.msg = "The market list id to be removed is not in the category";
    }
}
exports.MarketListIdNotInCategory = MarketListIdNotInCategory;
class InvalidFieldEnum extends Error {
    constructor() {
        super("6023: The field enum passed in doesn't match any in the match statement");
        this.code = 6023;
        this.name = "InvalidFieldEnum";
        this.msg = "The field enum passed in doesn't match any in the match statement";
    }
}
exports.InvalidFieldEnum = InvalidFieldEnum;
function fromCode(code) {
    switch (code) {
        case 6000:
            return new NotImplemented();
        case 6001:
            return new InvalidPrice();
        case 6002:
            return new InvalidQuantityLots();
        case 6003:
            return new InsufficientUsdc();
        case 6004:
            return new InsufficientTokens();
        case 6005:
            return new NonzeroLockedYes();
        case 6006:
            return new NonzeroLockedFUsdc();
        case 6007:
            return new NonzeroTempAccount();
        case 6008:
            return new MarketHasResolved();
        case 6009:
            return new MarketHasNotResolved();
        case 6010:
            return new WinningBracketIdInvalid();
        case 6011:
            return new BracketHasNotResolvedToYes();
        case 6012:
            return new BracketHasNotResolvedToNo();
        case 6013:
            return new SerumMarketNotClosed();
        case 6014:
            return new SerumMarketHasBeenClosed();
        case 6015:
            return new InvalidLotSizes();
        case 6016:
            return new MarketListHasNoBrackets();
        case 6017:
            return new OneMarketPerMarketList();
        case 6018:
            return new TooManyBids();
        case 6019:
            return new TooManyAsks();
        case 6020:
            return new NoOrdersInOpenOrders();
        case 6021:
            return new MarketListIdIsAlreadyInCategory();
        case 6022:
            return new MarketListIdNotInCategory();
        case 6023:
            return new InvalidFieldEnum();
    }
    return null;
}
exports.fromCode = fromCode;
function hasOwnProperty(obj, prop) {
    return Object.hasOwnProperty.call(obj, prop);
}
function fromTxError(err) {
    if (typeof err !== "object" ||
        err === null ||
        !hasOwnProperty(err, "logs") ||
        !Array.isArray(err.logs)) {
        return null;
    }
    const log = err.logs.slice(-1)[0];
    if (typeof log !== "string") {
        return null;
    }
    const components = log.split(`${programId_1.PROGRAM_ID} failed: custom program error: `);
    if (components.length !== 2) {
        return null;
    }
    let errorCode;
    try {
        errorCode = parseInt(components[1], 16);
    }
    catch (parseErr) {
        return null;
    }
    return fromCode(errorCode);
}
exports.fromTxError = fromTxError;
//# sourceMappingURL=errors.js.map